import axios from 'axios';
import UserService from '../userService/UserService';

const HttpMethods = {
  DELETE: 'DELETE',
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
};

const _axios = axios.create();

const configure = () => {
  _axios.interceptors.request.use(
    (config) => {
      if (UserService.isLoggedIn()) {
        const cb = () => {
          config.headers.Authorization = `Bearer ${UserService.getToken()}`;
          return Promise.resolve(config);
        };
        return UserService.updateToken(cb);
      }
      UserService.doLogin();
    },
    (error) => {
      return Promise.reject(error);
    },
  );
};

const getAxiosClient = () => _axios;

const HttpService = {
  HttpMethods,
  configure,
  getAxiosClient,
};

export default HttpService;
